import { Box } from "@mui/system";
import { Base64 } from "js-base64";
import Tab from "@mui/material/Tab";
import { Grid } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import { motion } from "framer-motion";
import { toast } from "react-hot-toast";
import Divider from "@mui/material/Divider";
import { useLocation } from "react-router-dom";
import Header from "../../Components/Header/Header";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import { useSelector, useDispatch, } from "react-redux";
import "../../../Assets/Styles/Containers/_lines.scss";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Assets/Styles/Containers/_lineDetails.scss";
import Media from "../../Components/LineDetails/Media/Media";
import AddItemButton from "../../Components/Button/AddItemButton";
import React, { useState, useEffect, useRef, useMemo } from "react";
import Location from "../../Components/LineDetails/Location/Location";
import NamePlate from "../../Components/LineDetails/NamePlate/NamePlate";
import ReportLibrarySideBar from "../ReportLibrary/ReportLibrarySideBar";
import { allInspectorFlagging, cleanPayloadForCommentReorder } from "../../Helpers/HelperFunctions";
import Description from "../../Components/LineDetails/Description/Description";
import Information from "../../Components/LineDetails/Information/Information";
import CommentDetails from "../../Components/LineDetails/CommentDetails/CommentDetails";
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { categoryLineRelation, UpdateTemplateDataSpecific } from "../../Helpers/ApiCall";
import AdditionalInput from "../../Components/LineDetails/AdditionalInput/AdditionalInput";
import { arrayMove, SortableContext, verticalListSortingStrategy, } from "@dnd-kit/sortable";
import CommentLibraryModal from "../../Components/LineDetails/CommentDetails/CommentLibraryModal";
import CommentDetailsNarrative from "../../Components/LineDetails/CommentDetails/CommentDetailsNarrative";
import { DragOverlay, DndContext, closestCenter, PointerSensor, useSensor, useSensors, } from "@dnd-kit/core";
import { activateLines, clearUpdatedInspectionData, getInspectionData, setShowCommentLibraryModal } from "../../Redux/Actions/CommonActions";
import { SortableNarrativeCommentItem, getCommentWrapperId } from "./SortableNarrativeCommentItem";
import NonNarrativeCL from "../../Components/LineDetails/CommentDetails/NonNarrativeCL";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import axios from "axios";
import { origin } from "../../Config/Api-constants";
import { LINE_DETAILS_SCROLL_CONTAINER_ID, SCROLL_RESTORE_DELAY_MS } from "../../Config/App-constants";
import { getMediaDomId } from "../../Helpers/MediaDomId";
import { getAllCategoryListData } from "../../Redux/Saga/Dashboard";
import { updateInspectionTemplateDataOffline } from "../../Redux/Actions/CommonActions";
import CommentRating from "../../Components/LineDetails/Rating/CommentRating";
import { resolveLineRatings } from "../../Helpers/LineRatingUtils";

const SCROLL_TO_DUPLICATED_COMMENT_DELAY_MS = 100;

const LineDetails = ({ onDragtoggle, setOnDragToggle, selectedMediaFiles, setSelectedMediaFiles, selectedImages, setSelectedImages }) => {

  const [showCommentModal, setShowCommentModal] = useState(false);
  const [lineData, setLineData] = useState();
  const [categoryData, setCategoryData] = useState();
  const [additionalInfoData, setAdditionalInfoData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [editComment, setEditComment] = useState(false);
  const [editemodelNum, seteditemodelNum] = useState(false);
  const [disableCommentBtn, setDisableCommentBtn] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [inspectionResponse, setInspectionResponse] = useState();
  const location = useLocation();
  const commentSectionRef = useRef(null);
  const detailsSectionRef = useRef(null);
  const containerRef = useRef(null);
  const uuidRef = useRef(null);
  const company = sessionStorage.getItem('asoCom');
  const isMobile = useMediaQuery("(max-width:900px)");
  // redux
  const dispatch = useDispatch();
  const isNarrative = location?.state?.isNarrative ? true : false;
  let templateId = location?.state?.template_id;
  let categoryId = location?.state?.category_id;
  let categoryName = location?.state?.category_name;
  let lineName = location?.state?.line?.prompt;
  let categoryUuid = location?.state?.category_uuid;
  let lineUuid = location?.state?.line_uuid;
  let target = location?.state?.target;
  let commentUuid = location?.state?.commentUuid;
  let mediaId = location?.state?.mediaId;
  let restoreScrollY = location?.state?.scrollY;
  let parentUuid = location?.state?.parent_uuid
  let addCommentFromLine = location?.state?.add_comment_from_line ? true : false;
  const storeData = useSelector((state) => state.CommonReducer);
  let templateData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId);
  let relationcategoryData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.categories?.find((category) => category.id === categoryId);
  let lineRelationData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.categories?.find((category) => category.id === categoryId).lines?.find((line) => line.uuid === lineUuid);
  let templateGuid = templateData?.master_template_guid;
  const assignColorList = storeData?.inspectionData?.data?.inspectorFlagList?.filter((item) => item.is_deleted !== 1) || [];
  const [value, setValue] = React.useState(0);
  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionResponse(storeData.inspectionData?.data);
    }
  }, [storeData.inspectionData]);

  const handleChange = (event, newValue) => {
    commentUuid = null;
    setValue(newValue);
    scrollToSection(newValue === 0 ? detailsSectionRef : commentSectionRef, newValue === 0 ? 100 : -120);
  };

  const handleTabChangeFromLine = (event, newValue) => {
    if (newValue === 1 && commentSectionRef.current) {
      setActiveTab(newValue);
      setTimeout(() => {
        commentSectionRef.current.scrollIntoView({ behavior: "smooth" });
        setDisableCommentBtn(false);
      }, 100);
    } else {
      setActiveTab(newValue);
    }
  };

  const latestDescriptionValuesRef = useRef(null);

  const locationhere = useLocation();
  const prevLocationRef = useRef(location.pathname);
  const requestIdRef = useRef(0);

  useEffect(() => {
    prevLocationRef.current = locationhere.pathname;
  }, [locationhere.pathname]);

  useEffect(() => {
    getAllCategoryListData()
  }, []);

  const debouncedDescriptionApiCallsRef = useRef({});
  const debouncedAdditionalInputApiCallsRef = useRef({});

  useEffect(() => {
    return () => {
      // Flush all debounced calls on unmount
      Object.values(debouncedDescriptionApiCallsRef.current).forEach((debouncedFunc) => {
        debouncedFunc.flush();
      });
      Object.values(debouncedAdditionalInputApiCallsRef.current).forEach((debouncedFunc) => {
        debouncedFunc.flush();
      });
    };
  }, []);


  // This is the API handler to be triggered after debounce
  const updateDescriptionDataAPI = useCallback(
    async (updatedValues, templateId, categoryId, lineUuid) => {
      requestIdRef.current += 1;

      const currentInspectionResponse = storeData;
      if (
        !currentInspectionResponse?.inspectionData?.data ||
        !Array.isArray(currentInspectionResponse.inspectionData.data.inspectiontemplates)
      ) return;

      try {
        const fullResponseData = JSON.parse(JSON.stringify(currentInspectionResponse.inspectionData.data));

        const templateIndex = fullResponseData.inspectiontemplates.findIndex((itm) => itm.template_id === templateId);
        const categoryIndex = fullResponseData.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
        const lineIndex = fullResponseData.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        const linIpIdx = fullResponseData.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.line_input_controls?.findIndex((ctrl) => ctrl.type === "Description");

        if ([templateIndex, categoryIndex, lineIndex, linIpIdx].includes(-1)) return;

        const inputControl = fullResponseData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].line_input_controls[linIpIdx];

        inputControl.values = updatedValues;
        inputControl.updated_at = await GetUTCTime();
        inputControl.data = updatedValues.filter((item) => item.is_selected).map((item) => item.value);

        const payload = {
          template_id: fullResponseData.inspectiontemplates[templateIndex].template_id,
          category_uuid: fullResponseData.inspectiontemplates[templateIndex].categories[categoryIndex].uuid,
          category_id: fullResponseData.inspectiontemplates[templateIndex].categories[categoryIndex].id,
          line_uuid: fullResponseData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].uuid,
          line_input_control: inputControl,
          inspection_guid: storeData.inspectionData?.data?.guid,
        };
        const controlId = inputControl.uuid || "default_desc";
        if (!debouncedDescriptionApiCallsRef.current[controlId]) {
          debouncedDescriptionApiCallsRef.current[controlId] = debounce(async (payload) => {
            try {
              const baseUrl = await origin();
              const sessionAPIKey = sessionStorage.getItem("CK");
              const sessionSecretKey = sessionStorage.getItem("SK");

              await axios({
                method: "post",
                url: `${baseUrl}store-checkbox-value`,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                  "api-key": `${Base64.decode(sessionAPIKey)}`,
                  "platform": "web",
                  "api-platform": "WRW",
                  "user_id": sessionStorage.getItem("UID"),
                  "product": sessionStorage.getItem("asoCom"),
                  "mode": "online",
                },
                data: payload,
              });

              console.log(`✅ Debounced Description API success for control: ${controlId}`);
            } catch (err) {
              console.error(`❌ Debounced Description API error for control: ${controlId}:`, err);
            }
          }, 1000);
        }

        dispatch(updateInspectionTemplateDataOffline(fullResponseData));
        debouncedDescriptionApiCallsRef.current[controlId](payload);

      } catch (err) {
        console.error("Description API Error:", err);
      }
    }, [dispatch, storeData]
  );

  const updateAdditionalInputDataAPI = useCallback(
    async (updatedValues, templateId, categoryId, lineUuid, controlId) => {
      requestIdRef.current += 1;
      const currentInspectionResponse = storeData;
      if (
        !currentInspectionResponse?.inspectionData?.data ||
        !Array.isArray(currentInspectionResponse.inspectionData.data.inspectiontemplates)
      ) return;

      try {
        const fullData = JSON.parse(JSON.stringify(currentInspectionResponse.inspectionData.data));
        const templateIndex = fullData.inspectiontemplates.findIndex((itm) => itm.template_id === templateId);
        const categoryIndex = fullData.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
        const lineIndex = fullData.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        const controlIndex = fullData.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.line_input_controls?.findIndex(
          (ctrl) => ctrl.type === "Additional Input" && (ctrl.uuid === controlId || ctrl.uuid === controlId)
        );
        if ([templateIndex, categoryIndex, lineIndex, controlIndex].includes(-1)) return;
        const inputControl = fullData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].line_input_controls[controlIndex];
        inputControl.values = updatedValues;
        inputControl.updated_at = await GetUTCTime();
        inputControl.data = updatedValues.filter((item) => item.is_selected).map((item) => item.value);
        const payload = {
          template_id: fullData.inspectiontemplates[templateIndex].template_id,
          category_uuid: fullData.inspectiontemplates[templateIndex].categories[categoryIndex].uuid,
          category_id: fullData.inspectiontemplates[templateIndex].categories[categoryIndex].id,
          line_uuid: fullData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].uuid,
          line_input_control: inputControl,
          inspection_guid: storeData.inspectionData?.data?.guid,
        };

        if (!debouncedAdditionalInputApiCallsRef.current[controlId]) {
          debouncedAdditionalInputApiCallsRef.current[controlId] = debounce(async (payload) => {
            try {
              const baseUrl = await origin();
              const sessionAPIKey = sessionStorage.getItem("CK");
              const sessionSecretKey = sessionStorage.getItem("SK");

              await axios({
                method: "post",
                url: `${baseUrl}store-checkbox-value`,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                  "api-key": `${Base64.decode(sessionAPIKey)}`,
                  "platform": "web",
                  "api-platform": "WRW",
                  "user_id": sessionStorage.getItem("UID"),
                  "product": sessionStorage.getItem("asoCom"),
                  "mode": "online",
                },
                data: payload,
              });

              console.log(`✅ Debounced API call success for control: ${controlId}`);
            } catch (err) {
              console.error(`❌ Debounced API Error (Additional Input) for control: ${controlId}:`, err);
            }
          }, 1000);
        }

        await dispatch(updateInspectionTemplateDataOffline(fullData));
        debouncedAdditionalInputApiCallsRef.current[controlId](payload);
      } catch (err) {
        console.error("API Error (Additional Input):", err);
      }
    },
    [dispatch, storeData]
  );


  // Initialize debounce only once


  const categorylineRelation = () => {
    categoryLineRelation(dispatch, {
      templateGuid: templateData?.master_template_guid,
      categoryUuid: relationcategoryData?.parent_uuid !== null ? relationcategoryData?.parent_uuid : relationcategoryData?.uuid,
      lineUuid: lineRelationData?.uuid,
      lineParentUuid: lineRelationData?.parent_uuid === null || lineRelationData?.parent_uuid === undefined ? lineRelationData?.uuid : lineRelationData?.parent_uuid,
    });
    console.log("inline")
    getAllCategoryListData(dispatch);
  };

  const handleCommentLibrary = () => {
    storeData?.categoryLineRelation === undefined && categorylineRelation();
    if (isNarrative) dispatch(setShowCommentLibraryModal(true));
    setDisableCommentBtn(false);
  };

  useEffect(() => {
    if (isNarrative && addCommentFromLine) {
      handleTabChangeFromLine(undefined, 1);
    }
  }, []);

  useEffect(() => {
    if (storeData.inspectionData) {
      setLineData(
        storeData?.inspectionData?.data?.inspectiontemplates
          ?.find((template) => template.template_id === templateId)
          ?.categories?.find((category) => category.id === categoryId)
          .lines?.find((line) => line.uuid === lineUuid)
      );
      let lineData = storeData?.inspectionData?.data?.inspectiontemplates
        ?.find((template) => template.template_id === templateId)
        ?.categories?.find((category) => category.id === categoryId)
        .lines?.find((line) => line.uuid === lineUuid);
      setAdditionalInfoData(lineData?.line_input_controls?.filter((data) => data.type === "Additional Input").sort((a, b) => a?.order - b?.order));
    }
  }, [storeData.inspectionData, storeData.loader, refresh]);

  useEffect(() => {
    const inspectionTemplates = storeData?.inspectionData?.data?.inspectiontemplates;
    if (!inspectionTemplates) return;

    const template = inspectionTemplates.find(t => t.template_id === templateId);
    const category = template?.categories?.find(c => c.id === categoryId);
    const line = category?.lines?.find(l => l.uuid === lineUuid);

    setLineData(line);
    setCategoryData(category);
    setAdditionalInfoData(
      line?.line_input_controls
        ?.filter(data => data.type === "Additional Input")
        ?.sort((a, b) => a?.order - b?.order)
    );

    dispatch(activateLines(""));
    dispatch(activateLines(location?.state?.line_uuid));
  }, [storeData?.inspectionData, templateId, categoryId, lineUuid]);


  useEffect(() => {
    if (storeData.updatedInspectionData && storeData.updatedInspectionData !== "") {
      dispatch(clearUpdatedInspectionData());
    }
  }, [storeData.updatedInspectionData]);

  useEffect(() => {
    if (storeData?.mediaUpdate) {
      let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem("AC"));
      let guid = sessionStorage.getItem("guid");
      let sessionUserId = Base64.decode(sessionStorage.getItem("UI"));
      dispatch(
        getInspectionData({
          guid: guid,
          associate_company: sessionAssociateCompanyKey,
          user_id: sessionUserId,
        })
      );
    }
  }, [storeData?.mediaUpdate]);




  useEffect(() => {
    if (storeData?.addCommentResponse !== "" && storeData?.addCommentResponse !== undefined) {
      toast.success(storeData?.addCommentResponse?.message);
    }
    if (storeData?.narrativeCommentAdded !== "" && storeData?.narrativeCommentAdded !== undefined) {
      toast.success(storeData?.addNarrativeCommentResponse?.message);
    }
  }, [storeData?.addCommentResponse, storeData?.narrativeCommentAdded]);


  const scrollToSection = (sectionRef, additionalOffset = 0) => {
    if (sectionRef.current && containerRef.current) {
      const container = containerRef.current;
      const headerHeight = document.getElementById("sticky_header") ? document.getElementById("sticky_header").offsetHeight : 0;
      const tabHeight = document.getElementById("details_tab") ? document.getElementById("details_tab").offsetHeight : 0;
      const totalOffset = headerHeight + tabHeight + additionalOffset;
      const containerTop = container.getBoundingClientRect().top;
      const sectionTop = sectionRef.current.getBoundingClientRect().top;
      const scrollY = sectionTop - containerTop - totalOffset;
      container.scrollTo({
        top: container.scrollTop + scrollY,
        behavior: "smooth",
      });
    }
  };

  const scrollToComment = (commentUuid) => {
    const commentElement = document.getElementById(commentUuid);
    if (commentElement) {
      commentElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const [duplicatedCommentUuid, setDuplicatedCommentUuid] = useState(null);

  // Wait for the duplicated comment to render (and its expand animation to start) before scrolling to it
  useEffect(() => {
    if (!duplicatedCommentUuid) return undefined;
    const timeout = setTimeout(() => {
      document.getElementById(getCommentWrapperId(duplicatedCommentUuid))?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, SCROLL_TO_DUPLICATED_COMMENT_DELAY_MS);
    return () => clearTimeout(timeout);
  }, [duplicatedCommentUuid]);

  useEffect(() => {
    if (value === 0) {
      scrollToSection(detailsSectionRef, 100);
    } else if (value === 1 && commentUuid) {
      scrollToSection(uuidRef, -120);
    }
  }, [value]);

  useEffect(() => {
    // Restores the exact clicked image (set by ShowMoreLess's pinturaNavigate,
    // PALM-15231) within whichever comment/line section the coarser scroll
    // below already brought into view. Returns whether it found the image.
    // Scoped inside the effect (rather than a sibling const) so it closes
    // over the current mediaId without needing its own, ever-changing
    // function identity in the dependency array below.
    const scrollToTargetMedia = () => {
      if (!mediaId) return false;
      // Same owner ShowMoreLess scoped the thumbnail's id by when it was tapped.
      const mediaOwnerUuid = target === "comment" ? commentUuid : lineUuid;
      const mediaElement = document.getElementById(getMediaDomId(mediaOwnerUuid, mediaId));
      if (!mediaElement) return false;
      mediaElement.scrollIntoView({ behavior: "smooth", block: "center" });
      return true;
    };

    if (target === "comment" && commentUuid) {
      // Scroll to the comment section after a delay of 0.1 seconds
      const timeout = setTimeout(() => {
        if (!isNarrative) {
          setValue(1);
        }
        scrollToSection(uuidRef);
        scrollToComment(commentUuid);
        // Refine to the exact image within that comment when we know which
        // one it was; if even the comment itself couldn't be found, fall
        // back to the saved scroll position rather than leaving the page
        // wherever its default mount position happens to be.
        if (!scrollToTargetMedia() && !document.getElementById(commentUuid) && typeof restoreScrollY === "number") {
          containerRef.current?.scrollTo({ top: restoreScrollY, behavior: "auto" });
        }
      }, SCROLL_RESTORE_DELAY_MS);

      // Clear the timeout if the component unmounts or the dependencies change
      return () => clearTimeout(timeout);
    } else if (target === "comment" && (commentUuid === undefined || commentUuid === null)) {
      const timeout = setTimeout(() => {
        if (!isNarrative) {
          setValue(1);
        }
        scrollToSection(commentSectionRef, -120);
        scrollToTargetMedia();
      }, SCROLL_RESTORE_DELAY_MS);
      // Clear the timeout if the component unmounts or the dependencies change
      return () => clearTimeout(timeout);
    } else if (target === "line") {
      const timeout = setTimeout(() => {
        if (!isNarrative) {
          // Scroll to the details section
          scrollToSection(detailsSectionRef);

          // Activate the details tab
          setValue(0);
        }
        if (!scrollToTargetMedia() && !detailsSectionRef.current && typeof restoreScrollY === "number") {
          containerRef.current?.scrollTo({ top: restoreScrollY, behavior: "auto" });
        }
      }, SCROLL_RESTORE_DELAY_MS);
      return () => clearTimeout(timeout);
    } else {
      if (!isNarrative) {
        // Scroll to the details section
        scrollToSection(detailsSectionRef);

        // Activate the details tab
        setValue(0);
      }
    }
  }, [target, commentUuid, lineUuid, isNarrative, mediaId, restoreScrollY]);

  useEffect(() => {
    const handleScroll = () => {
      if (detailsSectionRef.current && commentSectionRef.current && containerRef.current) {
        const containerTop = containerRef.current.getBoundingClientRect().top;
        const sectionTop = detailsSectionRef.current.getBoundingClientRect().top;
        if (sectionTop === containerTop) {
          setValue(0);
        }
      }
    };
    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  // reorder
  const [isDragging, setIsDragging] = useState(false);
  const [activeComment, setActiveComment] = useState(null);
  const [activeId, setActiveId] = useState(null);

  const onDragStart = ({ active }) => {
    setActiveId(active.id);
    const comment = visibleComments.find(c => c.uuid === active.id);
    setActiveComment(comment); // 💾 Store full comment data
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // drag starts only after 5px move
      },
    })
  );

  const updateSortedComments = async (updatedList) => {
    setActiveId(null);
    setIsDragging(false);
    setActiveComment(null);
    const templateIndex = inspectionResponse?.inspectiontemplates?.findIndex(
      (item) => item.template_id === templateId
    );
    const categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex(
      (item) => item.id === categoryId
    );
    const lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex(
      (line) => line.uuid === lineUuid
    );
    const now = await GetUTCTime();
    // Recompute order among non-deleted comments only (1-based)
    let orderCounter = 1;
    const updatedWithTimestamps = updatedList?.map((item) => {
      const isDeleted = item?.is_deleted === 1;
      return {
        ...item,
        order: isDeleted ? item?.order : orderCounter++,
        updated_at: now,
      };
    });
    const updatedData = { ...storeData.inspectionData.data };
    updatedData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments = updatedWithTimestamps;
    const filteredObject = cleanPayloadForCommentReorder(
      updatedData,
      templateIndex,
      categoryIndex,
      lineIndex
    );
    UpdateTemplateDataSpecific(dispatch, updatedData, filteredObject);
  };


  const visibleComments = useMemo(() => {
    const list = lineData?.comments?.filter(
      (comment) => comment?.is_deleted !== 1 && comment?.uuid
    ) || [];
    // Ensure stable display order reflects the 'order' field
    return [...list].sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
  }, [lineData?.comments]);

  const handleAddComment = () => {
    storeData?.categoryLineRelation === undefined && categorylineRelation();
    setShowCommentModal(true);
    setDisableCommentBtn(false);
    // setEditComment(false);
  };

  const allAssociatedCategoryColors = (category, assignColorList) => {
    const { catwiseFlagListData } = allInspectorFlagging(inspectionResponse?.inspectiontemplates);
    const categoryData = catwiseFlagListData.find((item) => item?.category_id === category?.uuid);
    if (!categoryData?.inspector_flagging_guids || categoryData?.inspector_flagging_guids?.length === 0) {
      return [];
    }
    const uniqueGuids = [...new Set(categoryData.inspector_flagging_guids)];
    return uniqueGuids
      .map((guid) => {
        const matchedColor = assignColorList?.filter((item) => item.is_deleted !== 1).find((item) => item.guid === guid);
        return matchedColor ? matchedColor.color_code : null;
      })
      ?.filter((item) => item !== null);
  };

  const assosiatedLineColor = (inspector_flagging_guids, assignColorList) => {
    if (!inspector_flagging_guids || inspector_flagging_guids?.length === 0) {
      return [];
    }
    return inspector_flagging_guids
      .map((guid) => {
        const matchedColor = assignColorList?.filter((item) => item.is_deleted !== 1).find((item) => item.guid === guid);
        return matchedColor ? matchedColor.color_code : null;
      })
      ?.filter((item) => item !== null);
  };

  return (
    <motion.div className="h_100 w_bg" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      {storeData?.scrolPage ? window.scrollTo(0, 0) : ""}
      <div
        id="editor"
        style={{
          width: `${width}vw`,
          height: `${height}vh`,
          position: "fixed",
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
          zIndex: "2",
        }}
      ></div>
      {!isNarrative &&
        <NonNarrativeCL
          showCommentModal={showCommentModal}
          setShowCommentModal={setShowCommentModal}
          templateId={templateId}
          categoryId={categoryId}
          lineName={lineName}
          lineUuid={lineUuid}
          editComment={editComment}
          setEditComment={setEditComment}
          disableCommentBtn={disableCommentBtn}
          setDisableCommentBtn={setDisableCommentBtn}
          categoryName={categoryData?.prompt || categoryName}
          isNarrative={isNarrative}
          categoryUuid={categoryUuid}
          existingCommentUuids={lineData?.comments?.filter((comment) => comment.is_deleted === 0)?.map((comment) => comment.uuid)}
          setLineData={setLineData}
          commentUuid={commentUuid}
          parentUuid={parentUuid}
        />}
      {isNarrative && (
        <CommentLibraryModal
          lineData={lineData}
          templateId={templateId}
          categoryId={categoryId}
          lineUuid={lineUuid}
          templateGuid={templateGuid}
          categoryUuid={categoryUuid}
          existingCommentUuids={lineData?.comments?.filter((comment) => comment.is_deleted === 0)?.map((comment) => comment.uuid)}
          categoryName={categoryData?.prompt || categoryName}
          categoryData={categoryData}
        />
      )}
      <div style={{ boxSizing: "border-box", display: "box" }}>
        <div className="line-details-parent-div">
          <div className="line-details-child-div" style={{ borderRight: !isMobile ? "1px solid #BEBEBE" : "none" }}>
            <Header title={lineData?.prompt} action="line" stickyHeader={true} lineData={lineData} categoryData={categoryData}
              assosiatedCategoryColors={allAssociatedCategoryColors(categoryData, assignColorList)}
              assosiatedLineColor={assosiatedLineColor(lineData?.inspector_flagging_guids, assignColorList)}
            />
            <Box sx={{ width: "100%" }}>
              {!isNarrative && (
                <Box className="sticky_lineDetails__tab" sx={{ borderBottom: 1, borderColor: "divider" }}>
                  {!isNarrative ? (
                    <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example" sx={{ height: "30px" }}>
                      <Tab id="details_tab" className="tab__label" onClick={() => scrollToSection(detailsSectionRef, 100)} label="Details" />
                      <Tab id="comments_tab" className="tab__label" onClick={() => scrollToSection(commentSectionRef, -120)} label="Comments" />
                    </Tabs>
                  ) : null}
                </Box>
              )}
              {isMobile ? (
                <ReportLibrarySideBar
                  selectedImages={selectedImages}
                  setSelectedImages={setSelectedImages}
                  onDragtoggle={onDragtoggle}
                  setOnDragToggle={setOnDragToggle}
                  selectedMediaFiles={selectedMediaFiles}
                  setSelectedMediaFiles={setSelectedMediaFiles}
                />
              ) : (
                ""
              )}
              <Box id={LINE_DETAILS_SCROLL_CONTAINER_ID} className={!isNarrative ? "tabs_container" : "tabs_container1"} ref={containerRef}>
                {/* Details tab */}
                {!isNarrative && (
                  <Box id="details_section" ref={detailsSectionRef} value={value} index={0} className="tab_panel">
                    {/* Description */}
                    <Description
                      data={lineData?.line_input_controls?.find((data) => data.type === "Description")}
                      action="line"
                      templateId={templateId}
                      categoryId={categoryId}
                      lineUuid={lineUuid}
                      onUpdate={(updatedValues) => {
                        latestDescriptionValuesRef.current = updatedValues;
                        updateDescriptionDataAPI(updatedValues, templateId, categoryId, lineUuid)
                      }
                      }
                    />
                    <Divider style={{ width: "100%" }} />
                    {/* ====================================================================================== */}
                    {/* Additional Information */}
                    {additionalInfoData?.map((additionalInfo) => additionalInfo?.is_deleted !== 1 && (
                      <>
                        <AdditionalInput data={additionalInfo} action="line" templateId={templateId} categoryId={categoryId} lineUuid={lineUuid}
                          onUpdate={(updatedValues) =>
                            updateAdditionalInputDataAPI(
                              updatedValues,
                              templateId,
                              categoryId,
                              lineUuid,
                              additionalInfo?.uuid || additionalInfo?.uuid // pass the control id to match input control
                            )
                          } />
                        <Divider style={{ width: "100%" }} />
                      </>
                    ))}
                    {!templateData?.is_texas && categoryData?.is_inspection_details !== 1 ? <Grid container sx={{ mt: "17px", mb: "12px", px: "16px" }}>
                      <CommentRating
                        data={resolveLineRatings(lineData, templateData?.rating_data, categoryData)}
                        title="Rating"
                        action="line_level"
                        templateId={templateId}
                        categoryId={categoryId}
                        lineUuid={lineUuid}
                        component={"line_inside"}
                      />
                    </Grid> : null}
                    <Divider style={{ width: "100%" }} />
                    {/* ====================================================================================== */}
                    {/* Media */}
                    <Media
                      data={lineData?.line_input_controls?.find((data) => data.type === "Media")}
                      title="Media"
                      action="line"
                      templateId={templateId}
                      categoryId={categoryId}
                      categoryUuid={categoryUuid}
                      toggle={onDragtoggle}
                      setOnDragToggle={setOnDragToggle}
                      selectedMediaFiles={selectedMediaFiles}
                      setSelectedMediaFiles={setSelectedMediaFiles}
                      setSelectedImages={setSelectedImages}
                      lineUuid={lineUuid}
                      setRefresh={setRefresh}
                      width={setWidth}
                      setWidth={setWidth}
                      height={height}
                      setHeight={setHeight}
                      isNarrative={isNarrative}
                      addCommentFromLine={addCommentFromLine}
                      component={"lineMedia"}
                    />
                    <Divider style={{ width: "100%" }} />

                    {/* ====================================================================================== */}
                    {/* Location */}
                    {templateData?.is_hip_template !== 1 ? <Location
                      data={lineData?.line_input_controls?.find((data) => data.type === "Location")}
                      title="Location"
                      action="line"
                      templateId={templateId}
                      categoryId={categoryId}
                      lineUuid={lineUuid}
                      type="line"
                    /> : null}
                    <Divider style={{ width: "100%" }} />
                    {/* ====================================================================================== */}

                    {/* Information */}
                    <Information data={lineData?.line_input_controls?.find((data) => data.type === "Information")} action="line" templateId={templateId} categoryId={categoryId} lineUuid={lineUuid} />
                    <Divider style={{ width: "100%" }} />
                    {/* ====================================================================================== */}

                    {/* Nameplate */}
                    <NamePlate
                      toggle={onDragtoggle}
                      selectedImages={selectedImages}
                      setSelectedImages={setSelectedImages}
                      selectedMediaFiles={selectedMediaFiles}
                      setSelectedMediaFiles={setSelectedMediaFiles}
                      data={lineData?.line_input_controls?.find((data) => data.type === "Nameplate")}
                      namePlatedata={lineData?.line_input_controls}
                      action="line"
                      templateId={templateId}
                      categoryId={categoryId}
                      lineUuid={lineUuid}
                      categoryUuid={categoryUuid}
                      editemodelNum={editemodelNum}
                      seteditemodelNum={seteditemodelNum}
                    />
                  </Box>
                )}
                {/* Comments tab */}
                <Divider style={{ width: "100%" }} sx={{ borderBottomWidth: 8 }} ref={commentSectionRef} />
                <Grid container className="cl_comment_title_section">
                  <Grid item xs={12} className="line_detail_des_title mb_0">
                    <span className="details_title">Comments</span>
                    <span className="add_comment_btn" onClick={() => { isNarrative ? handleCommentLibrary() : handleAddComment() }}>
                      <AddItemButton text="New comment" width="100%" />
                    </span>
                  </Grid>
                </Grid>
                <Grid container className="comment__container_divider">
                  <Divider style={{ width: "100%", marginTop: "15px" }} />
                </Grid>

                {lineData?.comments.filter((comment) => comment?.is_deleted !== 1)?.length === 0 ? (
                  <p className="empty_comment_section">No Comments</p>
                ) : (
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragStart={onDragStart}
                    modifiers={[restrictToVerticalAxis]}
                    onDragEnd={({ active, over }) => {
                      if (active.id !== over?.id) {
                        const oldIndex = lineData?.comments?.findIndex((c) => c?.uuid === active?.id);
                        const newIndex = lineData?.comments?.findIndex((c) => c?.uuid === over?.id);
                        const updatedList = arrayMove(lineData.comments, oldIndex, newIndex);
                        updateSortedComments(updatedList);
                      } else {
                        setActiveId(null);
                        setIsDragging(false);
                      }
                    }}
                  >
                    <SortableContext
                      items={visibleComments.map((c) => c.uuid)}
                      strategy={verticalListSortingStrategy}
                    >
                      {visibleComments?.map((comment, index) => (
                        <SortableNarrativeCommentItem
                          key={comment?.uuid}
                          comment={comment}
                          index={index}
                          render={(comment, index, setActivatorNodeRef, listeners) => (
                            <div id={comment.uuid} key={comment.uuid} style={{ opacity: comment.uuid === activeId ? 0 : 1 }}>
                              {isNarrative ? <CommentDetailsNarrative
                                uuid={comment.uuid}
                                updated_at={comment.updated_at}
                                comment_text={comment.comment_text}
                                lineData={lineData}
                                comment_dropdowns={comment.comment_dropdowns}
                                summaries={comment.summaries}
                                summary_comment_text={comment.summary_comment_text}
                                summary_comment_dropdowns={comment.summary_comment_dropdowns}
                                title={comment.title}
                                comment_input_controls={comment.comment_input_controls}
                                is_selected={comment.is_selected}
                                is_expanded={comment.is_expanded}
                                tags={comment.tags}
                                toggle={onDragtoggle}
                                setSelectedImages={setSelectedImages}
                                templateId={templateId}
                                categoryId={categoryId}
                                selectedMediaFiles={selectedMediaFiles}
                                setSelectedMediaFiles={setSelectedMediaFiles}
                                categoryUuid={categoryUuid}
                                lineUuid={lineUuid}
                                commentIndex={index}
                                isNarrative={isNarrative}
                                categoryName={categoryData?.prompt}
                                setLineData={setLineData}
                                dragHandleRef={setActivatorNodeRef}
                                dragListeners={listeners}
                                onCommentDuplicated={setDuplicatedCommentUuid}
                              /> : <CommentDetails
                                {...comment}
                                toggle={onDragtoggle}
                                setSelectedImages={setSelectedImages}
                                templateId={templateId}
                                categoryId={categoryId}
                                categoryUuid={categoryUuid}
                                lineName={lineName}
                                setSelectedMediaFiles={setSelectedMediaFiles}
                                selectedMediaFiles={selectedMediaFiles}
                                lineUuid={lineUuid}
                                width={setWidth}
                                setWidth={setWidth}
                                isHIP={templateData?.is_hip_template}
                                height={height}
                                setHeight={setHeight}
                                commentIndex={index}
                                focusedCommentUuid={commentUuid}
                                categoryName={categoryData?.prompt || categoryName}
                                setLineData={setLineData}
                                setShowCommentModal={setShowCommentModal}
                                showCommentModal={showCommentModal}
                                tags={comment.tags}
                                dragHandleRef={setActivatorNodeRef}
                                dragListeners={listeners}
                                parentUuid={parentUuid}
                                isNewlyDuplicated={comment.uuid === duplicatedCommentUuid}
                                onCommentDuplicated={setDuplicatedCommentUuid}
                              />}
                              {/* <Divider style={{ width: "94%", margin: "0px 18px" }} sx={{ borderBottomWidth: 1 }} /> */}
                            </div>
                          )}
                        />
                      ))}
                    </SortableContext>
                    <DragOverlay dropAnimation={null} style={{ transformOrigin: '0 0' }}>
                      {activeId ? <div style={{ transform: 'translateY(-20px)' }}>
                        {isNarrative ? (
                          <CommentDetailsNarrative
                            uuid={activeComment.uuid}
                            updated_at={activeComment.updated_at}
                            lineData={lineData}
                            comment_text={activeComment.comment_text}
                            comment_dropdowns={activeComment.comment_dropdowns}
                            summaries={activeComment.summaries}
                            summary_comment_text={activeComment.summary_comment_text}
                            summary_comment_dropdowns={activeComment.summary_comment_dropdowns}
                            title={activeComment.title}
                            comment_input_controls={activeComment.comment_input_controls}
                            is_selected={activeComment.is_selected}
                            is_expanded={activeComment.is_expanded}
                            tags={activeComment.tags}
                            toggle={onDragtoggle}
                            setSelectedImages={setSelectedImages}
                            templateId={templateId}
                            categoryId={categoryId}
                            selectedMediaFiles={selectedMediaFiles}
                            setSelectedMediaFiles={setSelectedMediaFiles}
                            categoryUuid={categoryUuid}
                            lineUuid={lineUuid}
                            commentIndex={visibleComments.findIndex(c => c.uuid === activeComment.uuid)}
                            isNarrative={isNarrative}
                            categoryName={categoryData?.prompt}
                            setLineData={setLineData}
                            dragHandleRef={null}
                            dragListeners={null}
                            isDragging
                          />
                        ) : (
                          <CommentDetails
                            {...activeComment}
                            toggle={onDragtoggle}
                            setSelectedImages={setSelectedImages}
                            templateId={templateId}
                            categoryId={categoryId}
                            categoryUuid={categoryUuid}
                            lineName={lineName}
                            setSelectedMediaFiles={setSelectedMediaFiles}
                            selectedMediaFiles={selectedMediaFiles}
                            lineUuid={lineUuid}
                            width={setWidth}
                            setWidth={setWidth}
                            isHIP={templateData?.is_hip_template}
                            height={height}
                            setHeight={setHeight}
                            commentIndex={visibleComments.findIndex(c => c.uuid === activeComment.uuid)}
                            categoryName={categoryData?.prompt || categoryName}
                            setLineData={setLineData}
                            setShowCommentModal={setShowCommentModal}
                            showCommentModal={showCommentModal}
                            dragHandleRef={null}
                            dragListeners={null}
                            isDragging
                            parentUuid={parentUuid}
                          />
                        )}
                      </div> : null}
                    </DragOverlay>
                  </DndContext>
                )}
                <Divider style={{ width: "100%" }} sx={{ borderBottomWidth: 8 }} />
              </Box>
            </Box>
          </div>
          {!isMobile ? (
            <div style={{ minHeight: "100vh", padding: "13px 3px 10px 3px" }}>
              <div style={{ position: "sticky", top: "23px" }}>
                <ReportLibrarySideBar
                  selectedImages={selectedImages}
                  setSelectedImages={setSelectedImages}
                  onDragtoggle={onDragtoggle}
                  setOnDragToggle={setOnDragToggle}
                  selectedMediaFiles={selectedMediaFiles}
                  setSelectedMediaFiles={setSelectedMediaFiles}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default LineDetails;